import {
    CategoryFilterOverlayComponent as SourceCategoryFilterOverlayComponent,
} from 'SourceComponent/CategoryFilterOverlay/CategoryFilterOverlay.component';

import './CategoryFilterOverlay.override.style';
import React from "react";
import CategoryConfigurableAttributes from '@scandipwa/scandipwa/src/component/CategoryConfigurableAttributes';
import CloseIcon from '@scandipwa/scandipwa/src/component/CloseIcon';
import Overlay from '@scandipwa/scandipwa/src/component/Overlay';
import { CATEGORY_FILTER_OVERLAY_ID } from '@scandipwa/scandipwa/src/component/CategoryFilterOverlay/CategoryFilterOverlay.config';
import ResetAttributes from '@scandipwa/scandipwa/src/component/ResetAttributes';

export class CategoryFilterOverlayComponent extends SourceCategoryFilterOverlayComponent {
    renderFilters() {
        const {
            availableFilters = {},
            customFiltersValues,
            toggleCustomFilter,
            isMatchingInfoFilter,
            getFilterUrl,
            isSearchPage,
        } = this.props;

        const filters = availableFilters;

        return (
            <CategoryConfigurableAttributes
                mix={{ block: 'CategoryFilterOverlay', elem: 'Attributes' }}
                isReady={isMatchingInfoFilter}
                configurable_options={filters}
                getLink={getFilterUrl}
                parameters={customFiltersValues}
                updateConfigurableVariant={toggleCustomFilter}
                isSearchPage={isSearchPage}
            />
        );
    }

    renderonFilterButtonClick() {
        const { onFilterButtonClick, onFilterClose } = this.props;
        onFilterButtonClick();
        onFilterClose();

        // const mainItems = document.getElementsByClassName('Router-MainItems');
        // const categoryPage = document.getElementsByClassName('CategoryPage');
        // if (mainItems?.length > 0) {
        //     mainItems[0].style.zIndex = "99";
        // }
        // // if (categoryPage?.length > 0) {
        // //     categoryPage[0].style.position = "relative";
        // //     categoryPage[0].style.top = "0px";
        // // }
        // document.documentElement.style.overflow = 'unset';
    }

    renderFilterHeader() {
        // const Overlay_isVisible = document.getElementsByClassName("Overlay_isVisible");

        // const mainItems = document.getElementsByClassName('Router-MainItems');
        // const categoryPage = document.getElementsByClassName('CategoryPage');

        // if (Overlay_isVisible?.length > 0) {
        //     if (mainItems?.length > 0) {
        //         mainItems[0].style.zIndex = "unset";
        //     }
        //     // if (categoryPage?.length > 0) {
        //     // categoryPage[0].style.position = "fixed";
        //     // categoryPage[0].style.top = "0px";
        //     // }
        //     document.documentElement.style.overflow = 'hidden';
        // } else {
        //     // if (mainItems?.length > 0) {
        //     //     mainItems[0].style.zIndex = "99";
        //     // }
        //     // if (categoryPage?.length > 0) {
        //     //     categoryPage[0].style.position = "relative";
        //     //     categoryPage[0].style.top = "0px";
        //     // }
        //     document.documentElement.style.overflow = 'unset';
        // }

        return (
            <div className='filters-header--section'>
                <span></span>
                <span>filters</span>
                <span onClick={() => this.renderonFilterButtonClick()}>
                    <CloseIcon />
                </span>
            </div>
        )
    }

    renderResetAttributes() {
        const { customFiltersValues, availableFilters, toggleCustomFilter, onSeeResultsClick } = this.props;

        return (
            <ResetAttributes
                customFiltersValues={customFiltersValues}
                availableFilters={availableFilters}
                toggleCustomFilter={toggleCustomFilter}
                onSeeResultsClick={onSeeResultsClick}
            />
        );
    }

    renderDefaultFilters() {
        return (
            <>
                {this.renderFilterHeader()}
                <div className='CategoryFilterOverlay-ResetSection'>
                    {this.renderResetAttributes()}
                    {/* {this.renderResetButton()} */}
                </div>
                {this.renderFilters()}
            </>
        );
    }

    renderContent() {
        const {
            totalPages,
            areFiltersEmpty,
            isProductsLoading,
        } = this.props;

        // if ((!isProductsLoading && totalPages === 0) || areFiltersEmpty) {
        //     return this.renderEmptyFilters();
        // }

        // if (areFiltersEmpty) {
        //     return this.renderMinimalFilters();
        // }

        return (
            <>
                {this.renderDefaultFilters()}
                {/* { this.renderSeeResults() } */}
            </>
        );
    }

    onClickSeeResults = () => {
        const { onSeeResultsClick } = this.props;

        onSeeResultsClick();
        window.location.reload();
    }

    renderSeeResults() {

        return (
            <div
                className="CategoryFilterOverlay-SeeResults"
            >
                <button
                    className="CategoryFilterOverlay-Button Button"
                    onClick={() => this.renderonFilterButtonClick()}
                >
                    SEE RESULTS
                </button>
            </div>
        );
    }

    render() {
        const {
            onVisible,
            onHide,
            totalPages,
            isProductsLoading,
            isContentFiltered,
            isCategoryAnchor,
            isSearchPage,
        } = this.props;

        // show CategoryFilterOverlay for 1. categories marked as `anchor` in Magento admin 2. Search page
        if ((!isProductsLoading && totalPages === 0 && !isContentFiltered) || (!isCategoryAnchor && !isSearchPage)) {
            return (
                <div className="CategoryFilterOverlay" />
            );
        }

        return (
            <Overlay
                onVisible={onVisible}
                onHide={onHide}
                mix={{ block: 'CategoryFilterOverlay' }}
                id={CATEGORY_FILTER_OVERLAY_ID}
                isRenderInPortal={false}
            >
                <div className="CategoryFilterOverlay-Wrapper">
                    {this.renderContent()}
                    {this.renderLoader()}
                </div>
                {this.renderSeeResults()}
            </Overlay>
        );
    }
}

export default CategoryFilterOverlayComponent;
